import React, { useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import TextArea from 'react-textarea-autosize'
import { If, Avatar } from 'src/Components'
import { DirectMessageButton } from 'src/Components/buyers/Button'
import styles from './QuestionSingle.module.scss'

const defaultProps = {
  inputValue: ''
}

const propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  inputValue: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  avatarUri: PropTypes.string,
  isLoading: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
}

const QuestionSingle = ({
  className,
  onChange,
  onSubmit,
  inputValue,
  name,
  placeholder,
  avatarUri,
  isLoading,
  onBlur,
  onFocus
}) => {
  const [focused, setFocused] = useState(false)

  return (
    <div
      data-qa='questionSingle'
      className={classnames(
        className,
        styles.question,
        avatarUri && styles.withAvatar,
        focused && styles.focused
      )}
    >
      <TextArea
        className={styles.textarea}
        value={inputValue}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        aria-label={`dm ${inputValue}`}
        onFocus={e => {
          setFocused(true)
          onFocus && onFocus(e)
        }}
        onBlur={e => {
          setFocused(false)
          onBlur && onBlur(e)
        }}
      />
      <If condition={avatarUri}>
        <Avatar className={styles.avatar} src={avatarUri} />
      </If>
      <DirectMessageButton
        className={styles.button}
        disabled={!inputValue && !placeholder}
        loading={isLoading}
        onClick={onSubmit}
      />
    </div>
  )
}

QuestionSingle.defaultProps = defaultProps

QuestionSingle.propTypes = propTypes

export default QuestionSingle
